/* eslint-disable camelcase */
import { Component } from 'react';

import ComponentHeader from '../form-elements/ComponentHeader';
import DropTarget from './DropTarget';
import ItemTypes from '../ItemTypes';

const accepts = [ItemTypes.BOX, ItemTypes.CARD];

class MultiColumnRowBase extends Component {
	render() {
		const {
			controls,
			data,
			editModeOn,
			getDataById,
			setAsChild,
			removeChild,
			seq,
			className,
			index
		} = this.props;
		const { child_items, pageBreakBefore } = data;
		let baseClasses = 'SortableItem rfb-item';
		if (pageBreakBefore) {
			baseClasses += ' alwaysbreak';
		}

		return (
			<div
				style={{ ...this.props.style, padding: '0px' }}
				className={baseClasses}
				data-testid={'SortableItem'}
			>
				<ComponentHeader {...this.props} />
				<div>
					<div className="row">
						{child_items.map((x, i) => (
							<div key={`${i}_${x || '_'}`} className={className}>
								{controls ? (
									controls[i].props?.children?.key !== 'individual-form-undefined' ? (
										controls[i]
									) : (
										''
									)
								) : (
									<DropTarget
										style={{ width: '100%' }}
										data={data}
										accepts={accepts}
										items={child_items}
										col={i}
										parent_index={index}
										editModeOn={editModeOn}
										_onDestroy={() => removeChild(data, i)}
										getDataById={getDataById}
										setAsChild={setAsChild}
										seq={seq}
									/>
								)}
							</div>
						))}
					</div>
				</div>
			</div>
		);
	}
}

export default MultiColumnRowBase;
